import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import ActionService from "../action.service";
import {Observable, of} from "rxjs";
import {environment} from "../../environments/environment";
import Pagination from "../../model/pagination";
import QueryEncoder from "../queryEncoder";
import {catchError, switchMap} from "rxjs/operators";
import CorrectionModel from "../../model/correction.model";

@Injectable()
export default class CorrectionService {
    public constructor(private http: HttpClient, private actionService: ActionService) {
    }

    public show(id): Observable<CorrectionModel> {
        return this.http.get<CorrectionModel>(environment.apiUrl + '/corrections/' + id);
    }

    public list(query?: string, page?: number, limit?: number, sort?: string, direction?: string, additionalFields?: any): Observable<Pagination<CorrectionModel>> {
        if(typeof query !== 'string') {
            query = '';
        }
        query = query || '';
        page = page || 1;
        limit = limit || 15;
        sort = sort || '';

        let sorting = {};
        sorting[sort] = direction;

        const q = {query, page, limit, sorting};

        if(additionalFields) {
            Object.assign(q, additionalFields);
        }

        return this.http.get<Pagination<CorrectionModel>>(environment.apiUrl + '/corrections?' + QueryEncoder.encodeURI(q));
    }

    public delete(correction: CorrectionModel): Observable<boolean> {
        return this.http.delete(environment.apiUrl + '/goals/' + correction.id).pipe(switchMap(result => of(true)), catchError(err => of(false)));
    }

    public update(correction: CorrectionModel): Observable<CorrectionModel> {
        return this.http.put<CorrectionModel>(environment.apiUrl + '/corrections/' + correction.id, correction);
    }

    public create(correction: CorrectionModel): Observable<any> {
        return this.http.post(environment.apiUrl + '/corrections', correction);
    }
}
